// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import Vant from 'vant'
import 'vant/lib/index.css'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import 'lib-flexible/flexible.js'
//因运维原因，暂停适配终端类型功能
//import "./utils/terminal-testing"
//import '@/assets/css/icon/iconfont.css'
import VideoPlayer from 'vue-video-player'

import utils from './utils'
import { MessageBox } from 'mint-ui'
import { Toast } from 'mint-ui'

import bus from './bus'
import moment from 'moment'

import clampy from '@clampy-js/vue-clampy'
import './assets/css/main.css'
import Calendar from 'vue-mobile-calendar'
import 'babel-polyfill'
import hls from 'videojs-contrib-hls'



// import Vconsole from 'vconsole'
// const vConsole = new Vconsole()
// Vue.use(vConsole)

// import vConsole from 'vconsole'
// new vConsole()
import Video from 'video.js'
import 'video.js/dist/video-js.css'
Vue.use(hls)
Vue.prototype.$video = Video
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(Calendar)

Vue.use(VideoPlayer)
Vue.use(clampy)
Vue.use(MintUI)
Vue.use(Vant)
Vue.filter('dateformat', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format("YYYY-MM-DD HH:mm:ss")
})
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$moment = moment
//兄弟组件通信方式
Vue.prototype.$EventBus = new Vue();


router.beforeEach((to, from, next) => {
  // 这里设置的是2个月后终止服务
 /* if (new Date().getTime() > new Date(2018, 10, 14).getTime()) {
    return
  }*/
    window.document.title =  utils.get('title') === null?'职业培训网络平台':utils.get('title')+'职业培训网络平台'
    // window.document.title = utils.get('title')+'职业培训网络平台'
  if (to.path == '/' && utils.getUserToken()) {
    next(false)
    router.replace('/index')
    return
  }

  if (to.path.indexOf('/personal') != -1) {
    next(false)

    if (!utils.getUserToken()) {
      utils.save('USER_TYPE', 'TOURIST')// 用户类型-游客
      MessageBox.confirm('您还没有登录，现在要登录吗？', '温馨提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        closeOnClickModal: false,
        type: 'info'
      })
        .then(() => {
          router.replace('/login')
        })
        .catch()
    } else {
      next()
    }
  } else {
    next()
  }
})

Vue.filter('htmlNewLine', function (value) {
  if (!value) {
    return value
  }
  return value.replace(/\n/g, '<br/>')
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  directives: {
    clampy
  },
  created () {
    bus.$on('loginExpired', () => {
      if (utils.getUserToken()) {
        //alert("登录失效，清空缓存")
        utils.clearUserInfo()
        // if (this.$route.path.indexOf('/index') >= 0) {
        //   location.reload()
        // } else {
          Toast('登录信息已经失效，请重新登录')
          this.$router.replace('/login')
        }
      //}
    })
  },
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js



// WEBPACK FOOTER //
// ./src/main.js